/** @format */

// 全角英数字から半角英数字に変換

export const fullWidthToHalfWidth = (data: string) => {
  return data.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
};
